import React from "react";
import { useNavigate } from "react-router";
import CreateNewPartnerModal from "./create-new-partner-modal";

const CreateNewPartner = () => {
  const navigate = useNavigate();

  return (
    <CreateNewPartnerModal
      open
      onClose={() => navigate("/hid-admin/dashboard/partner-organizations")}
    />
  );
};

export default CreateNewPartner;
